module.exports = __webpack_public_path__ + "img/modal-el-lock.55572e40.svg";